var EmailSentType = /*#__PURE__*/ function(EmailSentType) {
    EmailSentType["LoginOrCreateEML"] = "login_or_create_eml";
    EmailSentType["LoginOrCreateOTP"] = "login_or_create_otp";
    EmailSentType["ResetPassword"] = "reset_password";
    return EmailSentType;
}({});

export { EmailSentType };
//# sourceMappingURL=Events.mjs.map
